import { EventService, type EventDataInterface } from '@nextgen-web-framework/core';
import { CartEventsVersionsEnum, type CartPublishEventType, type CartSubscribeEventType } from '../types';
import type { Cart } from '../services';
import { eventsPayloadTransformer } from '../transformers';

// Get topic name for pubsub events
export const getEventTopicName = (event: string) => `cart.domain.${event}`;

// Cart Event Data Interface that extends EventDataInterface from core in framework
export interface CartEventDataInterface extends EventDataInterface {
  cart?: Cart;
  cartId: string;
  entryId?: string;
  cart_type?: string;
  cart_promo?: string;
  product_brand?: string[];
  product_businessVolume?: string[];
  product_id?: string[];
  product_name?: string[];
  product_pointValue?: string[];
  product_unitPrice?: string[];
  product_units?: string[];
  product_referrer?: string[];
  product_promo?: string[];
  message?: string;
}

// Get timestamp
const getEventTimeStamp = () => new Date();

// setting source system as metadata for cart
const getEventSourceSystem = () => 'purchase.cart';

// define version
const getCurrentEventVersion = () => CartEventsVersionsEnum['1.0.0'];

const getMetaData = (event: string) => ({
  timestamp: getEventTimeStamp(),
  sourceSystem: getEventSourceSystem(),
  eventName: event,
  version: getCurrentEventVersion(),
});

/* eslint-disable  @typescript-eslint/no-explicit-any */
export const CartEvents: any = {
  publishEvent({ event, payload, message, sync = false }: CartPublishEventType) {
    const eventData: CartEventDataInterface = {
      cart: payload.cart ?? ({} as Cart),
      metadata: getMetaData(event),
      cartId: payload.cartId,
      entryId: String(payload.entryId),
      cart_type: payload.cart_type,
      cart_promo: payload.cart_promo,
      product_brand: [payload.product_brand as string],
      product_businessVolume: [String(payload.product_businessVolume)],
      product_id: [payload.product_id as string],
      product_name: [payload.product_name as string],
      product_pointValue: [String(payload.product_pointValue)],
      product_unitPrice: [String(payload.product_unitPrice)],
      product_units: [String(payload.product_units)],
      product_referrer: [String(payload.product_referrer)],
      product_promo: [String(payload.product_promo)],
      message: message,
    };
    if (sync) {
      EventService.publishSync(getEventTopicName(event), eventData, eventsPayloadTransformer);
    } else {
      EventService.publish(getEventTopicName(event), eventData, eventsPayloadTransformer);
    }
  },
  subscribeEvents({ topics, version, cb }: CartSubscribeEventType) {
    const topicArray = Array.isArray(topics) ? topics : Array.of(topics);
    const subscription = topicArray.map((topic: string) => ({
      topic: getEventTopicName(topic),
      version,
    }));
    const subs = EventService.subscribeMultiple(subscription, cb);
    return subs;
  },
  unsubscribe(subs: string | string[]) {
    EventService.unsubscribeMultiple(subs);
  },
};
